import React from 'react';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import DailyMcqsNew from '../home/daily-mcqs/DailyMcqsNew';
import NotesList from '../home/notes/NotesList';
import VideoHomeListing from '../home/video-home-listing/VideoHomeListing';
import { GET_ALL_LIST_CONTEST_BY_LIMIT } from '../shared/HomeQueryList';

export default function FeatureList({ item }) {
  const {
    data,
    loading,
  } = useQuery(GET_ALL_LIST_CONTEST_BY_LIMIT, {
    variables: {
      listId: item?.id,
      limit: Number(item?.limit),
      offset: 0,
      isHome: true,
    },
    notifyOnNetworkStatusChange: true, // Allow loading state updates for fetchMore
  });
  const renderComponent = (type) => {
    if (type === 'video') {
      return (
        <VideoHomeListing
          data={data}
          pageSlug="feature-videos"
          paddingClasses="pt-[34px] lg:pt-[62px]"
        />
      );
    }
    if (type === 'pdf' || type === 'list') {
      return <NotesList data={data} loading={loading} />;
    }
    if (type === 'quiz') {
      return <DailyMcqsNew data={data} loading={loading} />;
    }
    return null;
  };
  return (
    <div>
      {renderComponent(data?.getListContents?.list?.type)}
    </div>
  );
}

FeatureList.propTypes = {
  item: PropTypes.object.isRequired,
  // id: PropTypes.string,
};
